module.exports = __webpack_public_path__ + "static/media/corsica.11859084.svg";